import { useMemo } from 'react';

export const useUrlParams = () => {
    return useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        
        return {
            apiUrl: params.get('urlServiceLiveness'),
            clientId: params.get('projectName') || 'default',
            transactionId: params.get('code') || params.get('codeTransaction'),
            platform: params.get('platform') || 'web',
            isMovil: params.get('isMovil') === 'true',
            emitReadyCam: params.get('emitReadyCam') || 'false',
            challenges: params.get('challenges'),
            timeout: params.get('timeout') ? parseInt(params.get('timeout')) : null,
            blinkCount: params.get('blinkCount') ? parseInt(params.get('blinkCount')) : null,
            logoUrl: params.get('logoUrl'),
            lottieUrl: params.get('lottieUrl')
        };
    }, []);
};
